angular.
module("dx.webapp.rubrics", [
	"digiexam.gradingMatrix",
	"dx.webapp.lists",
	"dx.webapp.navigation",
	"digiexam.components",
]);
